import axios from 'axios';
import { NrlkException } from "./exception.js";

const API_URL = window.API_URL || "https://api-dev.niralakka.fr";

/**
 * Événement émis sur `window` quand l'API répond 401 (session expirée ou
 * abonnement sans accès extranet). `event.detail.message` porte le message de l'API.
 * Les 403 (permission refusée) ne le déclenchent pas : ils ne ferment pas la session.
 */
export const UNAUTHORIZED_EVENT = "nrlk:unauthorized";

export class NrlkAPI {
  constructor(entreprise = "", token = null) {
    this.baseUrl = window.API_URL || API_URL;
    this.headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
    };
    this.setEntreprise(entreprise);
    this.setToken(token);
  }

  async setEntreprise(entreprise) {
    this.headers["Entreprise"] = entreprise;
  }

  async setToken(token) {
    this.headers["Token"] = token;
  }

  async getEntreprise() {
    return this.headers["Entreprise"];
  }

  async getToken() {
    return this.headers["Token"];
  }

  async sendRequest(method, endpoint, data = {}) {
    try {
      if (data instanceof FormData) {
        delete this.headers["Content-Type"];
        this.headers["Content-Type"] = "multipart/form-data";
      }
      if (method === "GET" || method === "DELETE") {
        data = { params: data };
      } else {
        data = { data: data };
      }
      const response = await axios({
        method: method,
        url: this.baseUrl + endpoint,
        headers: this.headers,
        withCredentials: true,
        ...data,
      });
      return response.data;
    } catch (error) {
      const status = error.response?.status ?? 0;
      const message = error.response?.data?.message;
      if (status === 401) {
        window.dispatchEvent(
          new CustomEvent(UNAUTHORIZED_EVENT, { detail: { message } })
        );
      }
      throw new NrlkException(
        error + " - " + (message || "Erreur inconnue"),
        status,
        "",
        error.response?.data ?? ""
      );
    }
  }

  async get(endpoint, params = {}) {
    return await this.sendRequest("GET", endpoint, params);
  }

  async post(endpoint, data) {
    return await this.sendRequest("POST", endpoint, data);
  }

  async put(endpoint, data) {
    return await this.sendRequest("PUT", endpoint, data);
  }

  async delete(endpoint) {
    return await this.sendRequest("DELETE", endpoint);
  }
}
